import DOMPurify from 'dompurify';

const QUILL_PURIFY_CONFIG = {
  // Quill stores video embeds as <iframe class="ql-video">; DOMPurify drops iframes by default.
  ADD_TAGS: ['iframe'],
  // Quill emits target="_blank" on links. Stripping it would make the value differ from Quill's own
  // output, and ReactQuill reloads the editor (losing the cursor) whenever they differ.
  ADD_ATTR: ['allowfullscreen', 'frameborder', 'target'],
};

/**
 * Cleans stored HTML before it reaches a Quill editor. Quill 1.x parses its value by assigning it
 * to the innerHTML of a live element, so handlers like <img onerror> fire before anything else
 * sanitizes it (CVE-2021-3163). Quill's own output passes through unchanged.
 */
export function sanitizeQuillHtml(html: string | null | undefined) {
  return DOMPurify.sanitize(html ?? '', QUILL_PURIFY_CONFIG);
}
